import { useEffect, useState, useRef } from "react";
import api from "../Api";
import { useAuth } from "../context/authcontext";
import { useFlash } from "../context/flashcontext";
import { useIsVoormanOnAnyProject } from "../hooks/useIsVoormanOnAnyProject";

export function useNavigation(navigate) {
    const { auth, logout } = useAuth();
    const [user, setUser] = useState(null);
    const { showFlash } = useFlash();
    const { isVoorman } = useIsVoormanOnAnyProject();
    const isMountedRef = useRef(true);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        if (!auth.userId) {
            setUser(null);
            return;
        }

        const fetchUser = async () => {
            try {
                const response = await api.get(`/users/${auth.userId}`);
                if (isMountedRef.current) {
                    setUser(response.data);
                }
            } catch (err) {
                // Optionally handle error
                console.error("Error fetching user in navigation:", err);
            }
        };

        fetchUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth.userId]); // Only depend on userId to prevent infinite loop

    const handleLogout = async () => {
        try {
            await logout();
            showFlash && showFlash("Uitgelogd.", "success");
            navigate("/login");
        } catch (err) {
            showFlash && showFlash("Uitloggen mislukt.", "error");
        }
    };

    const picLocation = user?.profile_picture ? `${user.profile_picture}` : null;

    return {
        auth,
        user,
        picLocation,
        handleLogout,
        isVoormanOnAnyProject: isVoorman,
    };
}
